module.exports = __webpack_public_path__ + "static/media/heatbliss-4.ac04165c.jpg";